import { ColDef } from '@ag-grid-community/core';
import { useTranslation } from '@thoughtspot/i18n';
import { Table } from '@thoughtspot/radiant-react/widgets/table/table';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Vertical } from '/@utils/layouts';
import { ShareObjectProps } from '../invite-users-v2.interface';
import { getTableDataFromSharables } from '../invite-users-v2.util';
import styles from './share-objects.module.scss';

export const ShareObjects: React.FC<ShareObjectProps> = ({
    setSelectedSharableIds,
    selectedSharableIds,
    objectList,
    onDataSourceClicked,
}) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    useEffect(() => {
        setData(getTableDataFromSharables(objectList, onDataSourceClicked));
    }, [objectList]);

    const options = {
        hasCheckboxes: true,
        hideSelectAllCheckbox: false,
        onRowsSelected: (selectedIds: string[]) => {
            if (!_.isEqual(selectedIds, selectedSharableIds)) {
                setSelectedSharableIds(selectedIds);
            }
        },
        selectedRowsIds: selectedSharableIds,
    };

    const columns: ColDef[] = [
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('invite.share.modal.liveboard'),
            colId: 'liveboard',
            flex: 1,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.dropdown],
            headerName: t('invite.share.modal.accessLevel'),
            colId: 'permission',
            width: 170,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.button],
            headerName: t('invite.share.modal.dataSources'),
            colId: 'dataSources',
            width: 160,
            sortable: false,
        },
    ];
    return (
        <Vertical>
            <Typography variant="body-normal">
                {t('invite.share.modal.body')}
            </Typography>
            <Table.ListView
                columns={columns}
                rowHeight={40}
                data={data}
                options={options}
                loading={false}
                className={styles.table_data}
            />
        </Vertical>
    );
};
